<div class="allergy-creator-container">
    <div class="header">
        <div class="header-actions">
            <h3>GP Details</h3>
            <button mat-icon-button (click)="openAddTeamMemberDialog(true)" matTooltip="Add a new doctor"
                color="primary">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
    <mat-form-field class="full-width" appearance="outline" (click)="openAddTeamMemberDialog(true)">
        <mat-label>GP Details</mat-label>
        <mat-chip-grid #chipGrid>
            <ng-container *ngFor="let member of medicalTeam">
                <mat-chip-row *ngIf="member.speciality === 'General Practice'" appTouchEdit (dblclick)="editTeamMember(member)"
                    [matTooltip]="getTooltipText(member)">
                    {{member.title}} {{member.name}} {{member.surname}}
                    <mat-icon *ngIf="member.isReferring" class="referring-icon">star</mat-icon>
                    <mat-icon *ngIf="reported(member)" class="patient-reported-mark" aria-label="Patient reported">person</mat-icon>
                    <button matChipRemove (click)="removeTeamMember(member)">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </ng-container>
        </mat-chip-grid>
        <input [matChipInputFor]="chipGrid" disabled />
        <mat-hint>Double click or tap and hold a doctor to edit their information</mat-hint>
    </mat-form-field>
    <div class="header m-t-20">
        <div class="header-actions">
            <h3>Specialist Details</h3>
            <button mat-icon-button (click)="openAddTeamMemberDialog()" matTooltip="Add a new specialist"
                color="primary">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
    <mat-form-field class="full-width" appearance="outline" (click)="openAddTeamMemberDialog()">
        <mat-label>Specialist Details</mat-label>
        <mat-chip-grid #specialistChipGrid>
            <ng-container *ngFor="let member of medicalTeam">
                <mat-chip-row *ngIf="member.speciality !== 'General Practice'" appTouchEdit (dblclick)="editTeamMember(member)"
                    [matTooltip]="getTooltipText(member)">
                    {{member.title}} {{member.name}} {{member.surname}}
                    <mat-icon *ngIf="member.isReferring" class="referring-icon">star</mat-icon>
                    <mat-icon *ngIf="reported(member)" class="patient-reported-mark" aria-label="Patient reported">person</mat-icon>
                    <button matChipRemove (click)="removeTeamMember(member)">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </ng-container>
        </mat-chip-grid>
        <input [matChipInputFor]="specialistChipGrid" disabled />
        <mat-hint>Double click or tap and hold a specialist to edit their information</mat-hint>
    </mat-form-field>


    <ng-template #addTeamMemberDialog>
        <h1 mat-dialog-title>Doctor Details</h1>
        <div mat-dialog-content>
            <div class="field-column">

                <!-- New doctors only: pick one of the practice's colleagues to fill the form in. -->
                <mat-form-field appearance="outline" class="m-r-10 colleague-search" *ngIf="colleagues.length && isNewMember">
                    <mat-label>Search your colleagues</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput [ngModel]="colleagueQuery" (ngModelChange)="onColleagueSearch($event)"
                        [matAutocomplete]="colleagueAuto" placeholder="Name, speciality, email or practice number">
                    <mat-autocomplete #colleagueAuto="matAutocomplete" class="colleague-search-panel" (optionSelected)="pickColleague($event.option.value)">
                        <mat-option *ngFor="let colleague of colleagueMatches" [value]="colleague">
                            <span class="colleague-option-name">{{ colleagueLabel(colleague) }}</span>
                            <span class="colleague-option-detail" *ngIf="colleague.speciality || colleague.practiceNumber">
                                {{ colleague.speciality }}{{ colleague.speciality && colleague.practiceNumber ? ' · ' : '' }}{{ colleague.practiceNumber }}
                            </span>
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint>From Settings &gt; MedicAI Network. Or type the details below.</mat-hint>
                </mat-form-field>

                <p class="hint">Note: if you are adding a GP, select "General Practice" from the Speciality options.
                </p>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Speciality</mat-label>
                    <mat-select [(ngModel)]="editingTeamMember.speciality" required>
                        <mat-option *ngFor="let speciality of specialities" [value]="speciality.value">
                            {{ speciality.text }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Title</mat-label>
                    <mat-select [(ngModel)]="editingTeamMember.title" required>
                        <mat-option *ngFor="let title of titles" [value]="title.value">
                            {{ title.text }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="editingTeamMember.name" placeholder="Name" type="text" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Surname</mat-label>
                    <input matInput [(ngModel)]="editingTeamMember.surname" placeholder="Surname" type="text" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Practice Number</mat-label>
                    <input matInput [(ngModel)]="editingTeamMember.practiceNumber" placeholder="Practice Number"
                        type="text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Email</mat-label>
                    <input matInput [(ngModel)]="editingTeamMember.email" placeholder="Email" type="email">
                </mat-form-field>

                <!-- <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Phone Number</mat-label>
                    <input matInput [(ngModel)]="editingTeamMember.phone" placeholder="Phone Number" type="tel">
                </mat-form-field> -->

                <app-intl-phone-input [preferredCountries]="['za']" [providedValue]="editingTeamMember.phone"
                    placeholder="Phone Number" (valueChange)="editingTeamMember.phone = $event" name="phone"
                    classList="full-width"></app-intl-phone-input>

                <mat-checkbox [(ngModel)]="editingTeamMember.isReferring">Referring doctor</mat-checkbox>
            </div>

        </div>
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" (click)="saveTeamMember()"
                [disabled]="!editingTeamMember.speciality || !editingTeamMember.title || !editingTeamMember.name || !editingTeamMember.surname">Save</button>
        </div>

    </ng-template>
</div>